const marimekkodata = [
  {
    statement: "it's good",
    participation: 28,
    stronglyAgree: 27,
    agree: 10,
    disagree: 26,
    stronglyDisagree: 12,
  },
  {
    statement: "it's sweet",
    participation: 13,
    stronglyAgree: 22,
    agree: 31,
    disagree: 29,
    stronglyDisagree: 26,
  },
  {
    statement: "it's spicy",
    participation: 18,
    stronglyAgree: 12,
    agree: 0,
    disagree: 20,
    stronglyDisagree: 25,
  },
  {
    statement: "worth eating",
    participation: 17,
    stronglyAgree: 20,
    agree: 24,
    disagree: 5,
    stronglyDisagree: 31,
  },
  {
    statement: "worth buying",
    participation: 11,
    stronglyAgree: 19,
    agree: 12,
    disagree: 7,
    stronglyDisagree: 31,
  },
]
export default marimekkodata;
